import { render } from "./Warehouses.vue?vue&type=template&id=ba059630"
import script from "./Warehouses.vue?vue&type=script&lang=ts"
export * from "./Warehouses.vue?vue&type=script&lang=ts"
script.render = render

export default script